import usePageMeta from "utils/usePageMeta";
import PageHero from "reusables/layouts/PageHero";
import ServicesSection from "reusables/sections/ServicesSection";
import HowItWorks from "reusables/sections/HowItWorks";

import propertyRoutes from "routes/property";
import routesToServiceData from "utils/routesToServiceData";

import one from "assets/images/Main/numbers/1.png";
import two from "assets/images/Main/numbers/2.png";
import three from "assets/images/Main/numbers/3.png";
import four from "assets/images/Main/numbers/4.png";
import five from "assets/images/Main/numbers/5.png";
import six from "assets/images/Main/numbers/6.png";

const propertySteps = [
  {
    image: one,
    name: "Get in Touch",
    label:
      "Contact us to discuss your property needs. We'll listen to your requirements and recommend the most suitable management service.",
  },
  {
    image: two,
    name: "Property Assessment",
    label:
      "We carry out a thorough assessment of your property, covering its condition, compliance status, and any immediate requirements before management begins.",
  },
  {
    image: three,
    name: "Agree Terms & Onboard",
    label:
      "We agree on the scope of service, fees, and timelines. Your property is then formally onboarded onto our management system.",
  },
  {
    image: four,
    name: "We Take Over",
    label:
      "From tenant communications to maintenance coordination, we handle the day-to-day management of your property so you don't have to.",
  },
  {
    image: five,
    name: "Regular Reporting",
    label:
      "You receive clear, regular updates on your property — including maintenance activity, inspections, and financial summaries.",
  },
  {
    image: six,
    name: "Ongoing Support",
    label:
      "Our team remains available to you at all times. As your needs evolve, we adapt our service to ensure your property continues to perform at its best.",
  },
];

function PropertyPage() {
  usePageMeta({
    title: "Spechs Property Services | Lettings & Property Management Ireland",
    description:
      "Full property management, let-only, block management, maintenance, and compliance services across Ireland. Trusted by landlords and property owners.",
    canonical: "https://www.spechs.ie/property/",
  });

  return (
    <PageHero
      title="Spechs Property Services"
      subtitle="We ensure a spotless, eco-friendly environment for your home or office."
    >
      <ServicesSection
        title="Our Services"
        description="We offer a wide range of property management services."
        data={routesToServiceData(propertyRoutes)}
      />
      <HowItWorks
        title="How It Works"
        description="Getting started with Spechs Property Services is straightforward. Here's what to expect:"
        steps={propertySteps}
      />
    </PageHero>
  );
}

export default PropertyPage;
